export const LANGUAGE_PARAM = 'NEXT_LOCALE';
export const X_URL_HEADER = 'x-url';
export const X_FORWARDED_HOST = 'x-forwarded-host';
export const PATHNAME_HEADER = 'pathname';
export const IS_BOT_HEADER = 'isBot';
export const OS_HEADER = 'os';
export const CF_COUNTRY_HEADER = 'cf-ipcountry';
export const CF_CONNECTING_IP = 'cf-connecting-ip';
export const X_REGION_HEADER = 'x-region-code';
export const I18N_LOCALE_HEADER = 'x-next-i18n-router-locale';
export const IS_RESTRICTED_HEADER = 'x-is-restricted';
export const IS_PRERENDER_HEADER = 'x-is-prerender';

export const MODAL_SEARCH_PARAM = 'modal';

export const DEMO_CURRENCY = 'FUN';
export const REF_PARAM = 'ref';
